import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TransactionErrorActionEnum } from 'src/shared/models/enums/transactionErrorAction.enum';
import { TransactionActionEnum } from 'src/shared/models/enums/transactionAction.enum';
import { Invoice } from '../models/invoice';

type IncomingBankPaymentActionConfirmProps = {
  open: boolean;
  invoice: Invoice | undefined;
  transactionAction: TransactionActionEnum;
  transactionErrorAction: TransactionErrorActionEnum;
  abort: () => void;
  confirm: () => void;
};

export const IncomingBankPaymentActionConfirm = (props: IncomingBankPaymentActionConfirmProps) => {
  const { open, invoice, transactionAction, transactionErrorAction, abort, confirm } = props;
  const { t } = useTranslation(['common', 'invoice']);

  const handleClose = () => {
    abort();
  };
  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{t('invoice:incomingBankPayment.confirmAction.header')}</DialogTitle>
      <Divider />
      <Alert severity='error'>{t('invoice:incomingBankPayment.confirmAction.warningMessage')}</Alert>
      <Divider />
      <DialogContent>
        {transactionAction === TransactionActionEnum.NewOcr && invoice !== undefined && (
          <>
            <Typography sx={{ fontWeight: 600 }}>{t('invoice:incomingBankPayment.confirmAction.newOcrHeader', { ocr: invoice.ocr })}</Typography>
            <Typography>{t('invoice:incomingBankPayment.confirmAction.newOcrDescription')}</Typography>
          </>
        )}
        {transactionAction === TransactionActionEnum.Incorrect && (
          <Typography variant='h6'>
            {t('invoice:incomingBankPayment.confirmAction.markPaymentAs', {
              action: t(`invoice:incomingBankPayment.transactionErrorEnum.${TransactionErrorActionEnum[transactionErrorAction]}`),
            })}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose}>{t('common:button.cancel')}</Button>
        <Button onClick={() => confirm()} variant='contained' color='primary' disableElevation autoFocus>
          {t('common:button.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
